import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map } from 'rxjs/operators/map'
import { JwtHelper, tokenNotExpired } from 'angular2-jwt'
import { Router } from '@angular/router'
import { Subject } from 'rxjs/Subject'
import { environment } from 'src/environments/environment'
@Injectable({
  providedIn: 'root'
})
export class MentorAuthService {
  baseUrl = environment.baseUrl
  url = this.baseUrl + 'mentor';
  timer: any;
  authStatus: Subject<boolean> = new Subject<boolean>();
  constructor(private httpClient: HttpClient, private router: Router) { }
  login(credentials) {
    return this.httpClient.post<any>(this.url + '/login', credentials).pipe(
      map(response => {
        if (response && response.token) {
          const jwtHelpers = new JwtHelper();
          localStorage.setItem('mentor-token', response.token);
          const expireTime = jwtHelpers.decodeToken(response.token).expiresIn
          this.timer = setTimeout(() => {
            this.logout()
          }, expireTime * 1000)
          return true;
        }
        return false
      })
    )
  }
  logout() {
    clearTimeout(this.timer)
    localStorage.removeItem('mentor-token');
    this.router.navigate(['/login/mentor'])
  }
  getUserName() {
    const jwtHelper = new JwtHelper()
    const token = localStorage.getItem('mentor-token')
    if (!token) return ""
    //  console.log(jwtHelper.decodeToken(token))
    let name = jwtHelper.decodeToken(token).firstName + " " + jwtHelper.decodeToken(token).lastName

    return name;
  }

  getLoggedUserId() {
    const jwtHelper = new JwtHelper()
    const token = localStorage.getItem('mentor-token')
    if (!token) return ""
    let id = jwtHelper.decodeToken(token).id
    return id;
  }
  isLoggedIn() {
    return tokenNotExpired('mentor-token')
  }
  getToken() {
    const token = localStorage.getItem('mentor-token')
    if (!token) return '';
    return token
  }
  verify() {
    return this.httpClient.get<any>(this.url + '/isLoggedIn')
  }
  confirmEmail(token) {
    return this.httpClient.get(this.url + '/verify/' + token)
  }


}
